(function () {
  if (window.__happymamiBundleInit) return;
  window.__happymamiBundleInit = true;

  var configEl = document.getElementById('happymami-bundle-config');
  var config = {};
  try {
    config = JSON.parse(configEl ? configEl.textContent : '{}');
  } catch (e) {
    config = {};
  }

  function hmMsg(path, fallback, vars) {
    if (typeof window.hmT === 'function') {
      var t = window.hmT(path, vars);
      if (t) return t;
    }
    return fallback;
  }

  var CHOICES_KEY = 'happymami_teat_choices';
  var CODES_KEY = 'happymami_teat_codes';
  var STORAGE_KEY = 'happymami_teat_sku';
  var FLOW_LETTER = { 1: 'L', 2: 'M', 3: 'R', 4: 'C' };
  var CART_ADD_URL = config.cartAdd || '/cart/add.js';
  var CART_UPDATE_URL = config.cartUpdate || '/cart/update.js';
  var CART_PAGE_URL = config.cartUrl || '/cart';
  // The price of the pack is fixed by the Happymami checkout function (see the bundles app), so no
  // discount code is ever applied from here. Kept as a function because the call sites check it.
  function packDiscountCode() {
    return '';
  }
  var TEAT_TO_N = {
    T1L: 'N10', T2L: 'N27', T3L: 'N42', T4L: 'N72',
    T1M: 'N34', T2M: 'N98', T3M: 'N59', T4M: 'N37',
    T1R: 'N06', T2R: 'N51', T3R: 'N08', T4R: 'N64',
    T1C: 'N89', T2C: 'N14', T3C: 'N05', T4C: 'N16',
  };
  var DEFAULT_SKU_MAP = {
    T1L: 58327893279103, T1M: 58327893311871, T1R: 58327893344639, T1C: 58327893377407,
    T2L: 58327893410175, T2M: 58327893442943, T2R: 58327893475711, T2C: 58327893508479,
    T3L: 58327893541247, T3M: 58327893574015, T3R: 58327893606783, T3C: 58327893639551,
    T4L: 58327893672319, T4M: 58327893705087, T4R: 58327893737855, T4C: 58327893770623,
  };
  var SKU_MAP = Object.assign({}, DEFAULT_SKU_MAP, config.skuMap || {});

  var EXTRA_PRODUCTS = config.extras || {};
  var VASO_VARIANTS = config.vasoVariants || [];
  var PACKS = {};
  (config.packs || []).forEach(function (pack) {
    if (!pack || !pack.id) return;
    PACKS[pack.id] = {
      bottles: Number(pack.bottles) || 1,
      extras: pack.extras || [],
      priceLabel: pack.price || pack.priceLabel || '',
      priceCents: Number(pack.priceCents) || 0,
      discountCode: packDiscountCode(pack, pack.id),
      name: pack.title || pack.name || '',
      compare: pack.compare || '',
      badge: pack.badge || '',
      banner: pack.banner || '',
      color: pack.color || '',
    };
    if (!PACKS[pack.id].priceCents) {
      PACKS[pack.id].priceCents = parseMoneyCents(PACKS[pack.id].priceLabel);
    }
  });
  if (!Object.keys(PACKS).length && !config.appPacks) {
    PACKS = {
      one: { bottles: 1, extras: [], priceLabel: '29,95 €', priceCents: 2995, discountCode: packDiscountCode({}, 'one'), color: '#f49898' },
      two: { bottles: 2, extras: [], priceLabel: '49,90 €', priceCents: 4990, discountCode: packDiscountCode({}, 'two'), color: '#f49898' },
      plus: { bottles: 2, extras: ['termo', 'dosificador'], priceLabel: '69,80 €', priceCents: 6980, discountCode: packDiscountCode({}, 'plus'), color: '#5a332f' },
    };
  }

  function packFromConfig() {
    if (config.defaultPack && PACKS[config.defaultPack]) return config.defaultPack;
    var packs = config.packs || [];
    for (var i = 0; i < packs.length; i++) {
      if (packs[i] && packs[i].featured && packs[i].id && PACKS[packs[i].id]) return packs[i].id;
    }
    if (packs[0] && packs[0].id) return packs[0].id;
    return 'one';
  }
  var firstPackId = packFromConfig();
  var state = { pack: firstPackId, secondDifferent: false, teatSku: '' };

  function applyDefaultPack(id) {
    if (!id || !PACKS[id]) return;
    firstPackId = id;
    state.pack = id;
    if (document.querySelector('.hm-pack[data-pack]')) selectPack(id);
  }

  // Texto propio de un nodo (sin el subtítulo, que va dentro del nombre).
  function ownText(node) {
    var out = '';
    for (var i = 0; i < node.childNodes.length; i++) {
      if (node.childNodes[i].nodeType === 3) out += node.childNodes[i].nodeValue;
    }
    return out.trim();
  }

  // Pinta (o quita) nombre, subtítulo, badge y texto inferior de una tarjeta y aplica los tamaños del bundle.
  function paintPackTexts(el, pack) {
    var nameEl = el.querySelector('.hm-pack__name');
    if (nameEl) {
      var subEl = nameEl.querySelector('.hm-pack__sub');
      if (pack.name) {
        for (var i = nameEl.childNodes.length - 1; i >= 0; i--) {
          if (nameEl.childNodes[i].nodeType === 3) nameEl.removeChild(nameEl.childNodes[i]);
        }
        nameEl.insertBefore(document.createTextNode(pack.name), nameEl.firstChild);
      }
      if (pack.subtitle) {
        if (!subEl) {
          subEl = document.createElement('span');
          subEl.className = 'hm-pack__sub';
          nameEl.appendChild(subEl);
        }
        subEl.textContent = pack.subtitle;
      } else if (subEl && pack.subtitleManaged) {
        nameEl.removeChild(subEl);
      }
    }
    var badgeEl = el.querySelector('.hm-badge');
    if (pack.badge) {
      if (!badgeEl) {
        badgeEl = document.createElement('span');
        badgeEl.className = 'hm-badge';
        el.insertBefore(badgeEl, el.firstChild);
      }
      badgeEl.textContent = pack.badge;
    } else if (badgeEl && pack.badgeManaged) {
      el.removeChild(badgeEl);
    }
    var bannerEl = el.querySelector('.hm-pack__banner');
    if (pack.banner) {
      if (!bannerEl) {
        bannerEl = document.createElement('p');
        bannerEl.className = 'hm-pack__banner';
        el.appendChild(bannerEl);
      }
      bannerEl.textContent = pack.banner;
    } else if (bannerEl && pack.bannerManaged) {
      el.removeChild(bannerEl);
    }
    [['--hm-pack-border', pack.borderColor], ['--hm-badge-bg', pack.badgeColor], ['--hm-banner-bg', pack.bannerColor]].forEach(function (c) {
      if (c[1]) el.style.setProperty(c[0], c[1]);
      else el.style.removeProperty(c[0]);
    });
    if (pack.badgeSize) el.style.setProperty('--hm-badge-size', pack.badgeSize + 'px');
    else el.style.removeProperty('--hm-badge-size');
    if (pack.bannerSize) el.style.setProperty('--hm-banner-size', pack.bannerSize + 'px');
    else el.style.removeProperty('--hm-banner-size');
    if (pack.subtitleSize) el.style.setProperty('--hm-sub-size', pack.subtitleSize + 'px');
    else el.style.removeProperty('--hm-sub-size');
  }

  function packCardDisplayLabels(id) {
    var el = document.querySelector('.hm-pack[data-pack="' + id + '"]');
    if (!el) return { name: '', sub: '', badge: '', banner: '' };
    var nameEl = el.querySelector('.hm-pack__name');
    var badgeEl = el.querySelector('.hm-badge');
    var bannerEl = el.querySelector('.hm-pack__banner');
    var subEl = el.querySelector('.hm-pack__sub');
    return {
      name: nameEl ? ownText(nameEl) : '',
      sub: subEl ? String(subEl.textContent || '').trim() : '',
      badge: badgeEl ? String(badgeEl.textContent || '').trim() : '',
      banner: bannerEl ? String(bannerEl.textContent || '').trim() : '',
    };
  }

  function paintPackCard(id, pack) {
    var el = document.querySelector('.hm-pack[data-pack="' + id + '"]');
    if (!el || !pack) return;
    if (pack.color) el.style.setProperty('--hm-pack-accent', pack.color);
    paintPackTexts(el, pack);
    var priceEl = el.querySelector('.hm-pack__price');
    if (priceEl && pack.priceLabel) {
      priceEl.textContent = '';
      if (pack.compare) {
        var struck = document.createElement('s');
        struck.textContent = pack.compare;
        priceEl.appendChild(struck);
        priceEl.appendChild(document.createTextNode(' '));
      }
      var strong = document.createElement('strong');
      strong.textContent = pack.priceLabel;
      priceEl.appendChild(strong);
    }
  }

  function releasePackTexts() {
    var wrap = document.querySelector('.hm-packs[data-hm-pending]');
    if (wrap) wrap.removeAttribute('data-hm-pending');
  }

  function applyRemotePacks(remote) {
    if (!remote) {
      releasePackTexts();
      return;
    }
    (remote.packs || []).forEach(function (pack) {
      if (!pack || !pack.id) return;
      var current = PACKS[pack.id] || {};
      var domLabels = packCardDisplayLabels(pack.id);
      // Lo que se edita en la app manda cuando está en el idioma de la visita (o es el español, el de origen);
      // si no, se queda el texto traducido del tema.
      var loc = pack.localized || {};
      var displayName = (loc.title && pack.title) || domLabels.name || current.name || '';
      var displayBadge = loc.badge ? pack.badge || '' : domLabels.badge || current.badge || '';
      var displayBanner = loc.banner ? pack.banner || '' : domLabels.banner || current.banner || '';
      var displaySub = loc.subtitle ? pack.subtitle || '' : domLabels.sub || '';
      PACKS[pack.id] = {
        bottles: Number(pack.bottles) || current.bottles || 1,
        extras: pack.extras && pack.extras.length ? pack.extras : current.extras || [],
        priceLabel: pack.price || pack.priceLabel || current.priceLabel || '',
        priceCents: Number(pack.priceCents) || 0,
        discountCode: packDiscountCode(pack, pack.id),
        name: displayName || pack.title || pack.name || '',
        compare: pack.compare || current.compare || '',
        badge: displayBadge,
        banner: displayBanner,
        subtitle: displaySub,
        badgeManaged: !!loc.badge,
        bannerManaged: !!loc.banner,
        subtitleManaged: !!loc.subtitle,
        badgeSize: Number(pack.badgeSize) || 0,
        bannerSize: Number(pack.bannerSize) || 0,
        subtitleSize: Number(pack.subtitleSize) || 0,
        borderColor: pack.borderColor || '',
        badgeColor: pack.badgeColor || '',
        bannerColor: pack.bannerColor || '',
        color: pack.color || current.color || '',
        colorMedia: pack.colorMedia || null,
      };
      if (!PACKS[pack.id].priceCents) {
        PACKS[pack.id].priceCents = parseMoneyCents(PACKS[pack.id].priceLabel);
      }
      paintPackCard(pack.id, PACKS[pack.id]);
    });
    if (remote.defaultPack) applyDefaultPack(remote.defaultPack);
    else updateCta();
    releasePackTexts();
  }

  /*
   * Packs de la app («Packs de la app Happymami» en el bloque): las tarjetas, sus piezas extra (termo,
   * dosificador, muselinas…) y el «Color del pack» salen de los bundles. Cada biberón sigue siendo vaso +
   * tetina, elegidos con el color, el tamaño y el flujo de siempre.
   */
  var EXTRA_ROLES = { termo: 1, dosificador: 1, otro: 1 };
  var COLOR_RE = /colou?r|tono|colore|farbe|^cor$|couleur|kolor/i;
  // Si una pieza no tiene el color del pack, el más parecido (las muselinas no tienen violeta ni menta).
  var COLOR_ALIASES = { menta: ['turquesa', 'verde'], violeta: ['rosa'], rosa: ['rosa'] };
  // Cada color en los idiomas de la tienda: los nombres de las variantes llegan traducidos.
  var COLOR_FAMILIES = {
    menta: ['menta', 'mint', 'menthe', 'minze', 'mięt', 'miet'],
    rosa: ['rosa', 'pink', 'rose', 'róż', 'roz'],
    violeta: ['violeta', 'violet', 'viola', 'violett', 'lila', 'lilás', 'lilas', 'lavanda', 'lavender', 'fiolet', 'purple'],
    turquesa: ['turquesa', 'turquoise', 'turchese', 'türkis', 'turkis', 'turkus', 'aqua'],
    verde: ['verde', 'green', 'vert', 'grün', 'grun', 'zielon']
  };

  function escHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  function extraFromSlot(pack, slot, index) {
    var item = (slot.items || [])[0];
    if (!item) return null;
    var only = (slot.variants || []).map(String);
    var swatches = {};
    (item.optionValues || []).forEach(function (option) {
      (option.values || []).forEach(function (value) {
        if (value.color) swatches[String(value.name).toLowerCase()] = value.color;
      });
    });
    var variants = (item.variants || [])
      .filter(function (variant) {
        return !only.length || only.indexOf(String(variant.id)) >= 0;
      })
      .map(function (variant) {
        return {
          id: Number(variant.id),
          sku: variant.sku || '',
          title: variant.title || '',
          options: variant.options || [],
          available: variant.available !== false,
          image: variant.image || item.image || '',
        };
      });
    if (!variants.length) return null;
    return {
      key: pack.id + '--' + index,
      role: slot.role,
      qty: Number(slot.qty) || 1,
      title: item.title || '',
      featuredImage: item.image || '',
      options: (item.options || []).map(function (name) {
        return { name: name };
      }),
      swatches: swatches,
      variants: variants,
    };
  }

  function extraLabel(extra) {
    var copy = config.copy || {};
    if (config.singlePack && extra.role === 'termo' && copy.singleTermo) return copy.singleTermo;
    if (config.singlePack && extra.role === 'dosificador' && copy.singleDosificador) return copy.singleDosificador;
    if (extra.role === 'termo' && copy.termo) return copy.termo;
    if (extra.role === 'dosificador' && copy.dosificador) return copy.dosificador;
    return extra.title;
  }

  function renderExtraPicker(packId, extra) {
    var wrap = document.createElement('div');
    wrap.className = 'hm-extra';
    wrap.setAttribute('data-hm-extra', extra.key);
    wrap.setAttribute('data-hm-pack-extra', packId);
    if (extra.variants.length <= 1) return null;
    var html = '';
    extra.options.forEach(function (option, index) {
      var values = [];
      extra.variants.forEach(function (variant) {
        var value = variant.options[index];
        if (value && values.indexOf(value) < 0 && variant.available) values.push(value);
      });
      if (values.length <= 1) return;
      var isColor = COLOR_RE.test(option.name);
      html +=
        '<div class="hm-option" data-hm-required="extra-' + escHtml(extra.key) + '-' + index + '">' +
        '<p class="hm-option__label">' + escHtml(index === 0 ? extraLabel(extra) : option.name) + '</p>' +
        '<p class="hm-option__error">' + escHtml(hmMsg('extras.select', 'Elige una opción')) + '</p>' +
        '<div class="' + (isColor ? 'hm-swatches' : 'hm-pills') + '" role="list">' +
        values
          .map(function (value, i) {
            var hex = extra.swatches[String(value).toLowerCase()] || '';
            return (
              '<button type="button" class="' + (isColor ? 'hm-swatch' : 'hm-pill') + ' hm-extra-choice' + (i === 0 ? ' is-selected' : '') + '"' +
              ' data-hm-extra-key="' + escHtml(extra.key) + '" data-hm-extra-option="' + index + '" data-value="' + escHtml(value) + '"' +
              ' aria-label="' + escHtml(value) + '" title="' + escHtml(value) + '"' +
              (hex ? ' data-hm-hex="' + escHtml(hex) + '"' : '') +
              '>' + (isColor ? '' : escHtml(value)) + '</button>'
            );
          })
          .join('') +
        '</div></div>';
    });
    if (!html) return null;
    wrap.innerHTML = html;
    return wrap;
  }

  function renderAppCard(pack, selected) {
    var card = document.createElement('article');
    card.className = 'hm-pack' + (selected ? ' is-selected' : '');
    card.setAttribute('data-pack', pack.id);
    card.setAttribute('data-bottles', String(pack.bottles));
    card.style.setProperty('--hm-pack-accent', pack.color || '#f49898');
    if (pack.borderColor) card.style.setProperty('--hm-pack-border', pack.borderColor);
    if (pack.badgeColor) card.style.setProperty('--hm-badge-bg', pack.badgeColor);
    if (pack.bannerColor) card.style.setProperty('--hm-banner-bg', pack.bannerColor);
    if (pack.badgeSize) card.style.setProperty('--hm-badge-size', pack.badgeSize + 'px');
    if (pack.bannerSize) card.style.setProperty('--hm-banner-size', pack.bannerSize + 'px');
    if (pack.subtitleSize) card.style.setProperty('--hm-sub-size', pack.subtitleSize + 'px');
    card.innerHTML =
      (pack.badge ? '<span class="hm-badge">' + escHtml(pack.badge) + '</span>' : '') +
      '<button type="button" class="hm-pack__header" data-hm-select-pack="' + escHtml(pack.id) + '">' +
      '<span class="hm-radio" aria-hidden="true"></span>' +
      '<span class="hm-pack__name">' + escHtml(pack.name) +
      (pack.subtitle ? '<span class="hm-pack__sub">' + escHtml(pack.subtitle) + '</span>' : '') +
      '</span>' +
      '<span class="hm-pack__price">' +
      (pack.compare ? '<s>' + escHtml(pack.compare) + '</s> ' : '') +
      '<strong>' + escHtml(pack.priceLabel) + '</strong></span>' +
      '</button>' +
      '<div class="hm-pack__slot" data-hm-slot></div>' +
      (pack.banner ? '<p class="hm-pack__banner">' + escHtml(pack.banner) + '</p>' : '');
    card.querySelector('[data-hm-select-pack]').addEventListener('click', function () {
      selectPack(pack.id);
    });
    return card;
  }

  // Las variantes que llegan de la app salen de la Admin API: incluyen las que se quitaron del catálogo del
  // mercado. La tienda (/products/<handle>.js) solo da las que se venden aquí, así que se queda con esas.
  function reconcileStorefront(packs) {
    var live = {};
    (packs || []).forEach(function (pack) {
      (pack.slots || []).forEach(function (slot) {
        (slot.items || []).forEach(function (item) {
          if (item && item.handle) live[item.handle] = null;
        });
      });
    });
    var handles = Object.keys(live);
    if (!handles.length) return Promise.resolve(packs);
    return Promise.all(
      handles.map(function (handle) {
        return fetch('/products/' + encodeURIComponent(handle) + '.js', {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        })
          .then(function (response) {
            return response.ok ? response.json() : null;
          })
          .then(function (product) {
            if (product && product.variants && product.variants.length) live[handle] = product.variants;
          })
          .catch(function () {});
      })
    ).then(function () {
      (packs || []).forEach(function (pack) {
        (pack.slots || []).forEach(function (slot) {
          slot.items = (slot.items || [])
            .map(function (item) {
              var variants = item && live[item.handle];
              if (!variants) return item;
              var byId = {};
              variants.forEach(function (variant) {
                byId[String(variant.id)] = variant;
              });
              item.variants = (item.variants || [])
                .filter(function (variant) {
                  return byId[String(variant.id)];
                })
                .map(function (variant) {
                  variant.available = variant.available !== false && byId[String(variant.id)].available !== false;
                  return variant;
                });
              return item;
            })
            .filter(function (item) {
              return item && item.variants && item.variants.length;
            });
        });
      });
      return packs;
    });
  }

  function applyAppPacks(remote) {
    var list = document.querySelector('[data-hm-packs]');
    var extrasWrap = document.querySelector('[data-hm-extras]');
    var packs = ((remote && remote.packs) || []).filter(function (pack) {
      return pack && pack.id && Number(pack.bottles) > 0 && (!config.singlePack || pack.id === config.singlePack);
    });
    if (!list) return;
    if (!packs.length) {
      list.innerHTML = '';
      return;
    }
    PACKS = {};
    packs.forEach(function (pack) {
      var extras = [];
      (pack.slots || []).forEach(function (slot, index) {
        if (!EXTRA_ROLES[slot.role]) return;
        var extra = extraFromSlot(pack, slot, index);
        if (!extra) return;
        EXTRA_PRODUCTS[extra.key] = extra;
        extras.push(extra.key);
      });
      PACKS[pack.id] = {
        bottles: Number(pack.bottles) || 1,
        extras: extras,
        priceLabel: pack.price || '',
        priceCents: Number(pack.priceCents) || parseMoneyCents(pack.price),
        compareCents: Number(pack.compareCents) || 0,
        discountCode: '',
        name: pack.title || pack.name || '',
        compare: pack.compare || '',
        badge: pack.badge || '',
        banner: pack.banner || '',
        subtitle: pack.subtitle || '',
        badgeSize: Number(pack.badgeSize) || 0,
        bannerSize: Number(pack.bannerSize) || 0,
        subtitleSize: Number(pack.subtitleSize) || 0,
        borderColor: pack.borderColor || '',
        badgeColor: pack.badgeColor || '',
        bannerColor: pack.bannerColor || '',
        color: pack.color || '',
        packColor: !!pack.packColor,
        colorMedia: pack.colorMedia || null,
      };
    });
    var first = remote.defaultPack && PACKS[remote.defaultPack] ? remote.defaultPack : packs[0].id;
    list.innerHTML = '';
    if (!config.singlePack) {
      packs.forEach(function (pack) {
        list.appendChild(renderAppCard(PACKS[pack.id] ? Object.assign({ id: pack.id }, PACKS[pack.id]) : pack, pack.id === first));
      });
    } else {
      // Pack fijo: sin tarjetas; las filas se llaman «Color del biberón», «Tamaño del vaso»…
      var copy = config.copy || {};
      var colorLabel = document.querySelector('[data-hm-color-label]');
      if (colorLabel && copy.singleColor) colorLabel.textContent = copy.singleColor;
      var sizeLabel = document.querySelector('[data-hm-required="size"] .hm-option__label');
      if (sizeLabel && copy.singleSize) sizeLabel.textContent = copy.singleSize;
      var flowLabel = document.querySelector('[data-hm-required="flow"] .hm-option__label');
      if (flowLabel && copy.singleFlow) flowLabel.textContent = copy.singleFlow;
      // Orden de la ficha: color, tamaño, flujo, termo, dosificador.
      var flowRow = document.querySelector('#hm-pack-options > [data-hm-required="flow"]');
      var sizeRow = document.querySelector('#hm-pack-options > [data-hm-required="size"]');
      if (flowRow && sizeRow) sizeRow.parentNode.insertBefore(flowRow, sizeRow.nextSibling);
    }
    if (extrasWrap) {
      extrasWrap.innerHTML = '';
      packs.forEach(function (pack) {
        if (PACKS[pack.id].packColor) return;
        PACKS[pack.id].extras.forEach(function (key) {
          var picker = renderExtraPicker(pack.id, EXTRA_PRODUCTS[key]);
          if (picker) extrasWrap.appendChild(picker);
        });
      });
      bindExtraChoices();
    }
    firstPackId = first;
    state.pack = first;
    selectPack(first);
  }

  if (config.packsUrl) {
    // Última respuesta guardada: se pinta en cuanto hay HTML (sin esperar a la red) y luego se refresca.
    var cacheKey = 'hmPacks:' + config.packsUrl;
    var cached = null;
    if (!config.appPacks) {
      try {
        cached = JSON.parse(localStorage.getItem(cacheKey) || 'null');
      } catch (e) {}
      var paintCached = function () {
        if (cached) applyRemotePacks(cached);
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paintCached);
      else paintCached();
      // Si la app no contesta, se enseñan los textos del tema.
      setTimeout(releasePackTexts, 2500);
    }
    fetch(config.packsUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (remote) {
        if (!config.appPacks) {
          if (remote) {
            try {
              localStorage.setItem(cacheKey, JSON.stringify(remote));
            } catch (e) {}
          }
          applyRemotePacks(remote);
          return;
        }
        return reconcileStorefront((remote && remote.packs) || []).then(function () {
          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', function () {
              applyAppPacks(remote);
            });
          } else {
            applyAppPacks(remote);
          }
        });
      })
      .catch(function () {
        releasePackTexts();
      });
  }

  function storageGet(key) {
    try {
      return sessionStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }
  function storageSet(key, value) {
    try {
      sessionStorage.setItem(key, value);
    } catch (e) {}
  }
  function storageRemove(key) {
    try {
      sessionStorage.removeItem(key);
    } catch (e) {}
  }
  function normalizeAnatomy(value) {
    var match = String(value || '')
      .toUpperCase()
      .match(/T[1-4](?![0-9])/);
    return match ? match[0].slice(0, 2) : '';
  }
  function normalizeTeat(value) {
    var match = String(value || '')
      .toUpperCase()
      .match(/T[1-4][LMRC]/);
    return match ? match[0] : '';
  }
  function teatFromFlow(anatomy, flowCode) {
    var letter = FLOW_LETTER[Number(flowCode)] || FLOW_LETTER[flowCode];
    return anatomy && letter ? anatomy + letter : '';
  }
  function selectedAttr(selector, attr) {
    var el = document.querySelector(selector + '.is-selected');
    return el ? el.getAttribute(attr) || '' : '';
  }
  function indexTeatSku(map, sku, id) {
    if (!id) return;
    var raw = String(sku || '').trim();
    if (raw) {
      map[raw] = id;
      map[raw.toUpperCase()] = id;
    }
    var teat = normalizeTeat(raw);
    if (teat) map[teat] = id;
    var nCode = raw.toUpperCase();
    Object.keys(TEAT_TO_N).forEach(function (teatSku) {
      if (TEAT_TO_N[teatSku] === nCode) map[teatSku] = id;
    });
  }
  (config.teatVariants || []).forEach(function (variant) {
    if (!variant) return;
    indexTeatSku(SKU_MAP, variant.sku, variant.id);
    indexTeatSku(SKU_MAP, variant.title, variant.id);
  });
  Object.keys(TEAT_TO_N).forEach(function (teat) {
    if (SKU_MAP[teat] && !SKU_MAP[TEAT_TO_N[teat]]) SKU_MAP[TEAT_TO_N[teat]] = SKU_MAP[teat];
  });
  function resolveTeatId(sku) {
    var teat = normalizeTeat(sku);
    if (teat && SKU_MAP[teat]) return SKU_MAP[teat];
    var raw = String(sku || '').trim().toUpperCase();
    if (raw && SKU_MAP[raw]) return SKU_MAP[raw];
    if (teat && TEAT_TO_N[teat] && SKU_MAP[TEAT_TO_N[teat]]) return SKU_MAP[TEAT_TO_N[teat]];
    return 0;
  }
  function parseMoneyCents(label) {
    var text = String(label || '').replace(/[^\d,.-]/g, '').trim();
    if (!text) return 0;
    if (text.indexOf(',') >= 0 && text.indexOf('.') >= 0) {
      if (text.lastIndexOf(',') > text.lastIndexOf('.')) text = text.replace(/\./g, '').replace(',', '.');
      else text = text.replace(/,/g, '');
    } else if (text.indexOf(',') >= 0) {
      text = text.replace(',', '.');
    }
    var n = parseFloat(text);
    return isNaN(n) ? 0 : Math.round(n * 100);
  }
  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      var v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
  function jsonFetch(url, options) {
    return fetch(url, options).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw new Error((data && (data.description || data.message)) || hmMsg('bundle.cart_error', 'Error de carrito'));
        return data;
      });
    });
  }

  function selectedValue(selector) {
    var el = document.querySelector(selector + '.is-selected');
    return el
      ? el.getAttribute('data-hm-color') ||
          el.getAttribute('data-hm-size') ||
          el.getAttribute('data-hm-color-b') ||
          el.getAttribute('data-hm-size-b') ||
          el.getAttribute('data-hm-flow') ||
          el.getAttribute('data-hm-flow-b')
      : '';
  }
  function variantMatches(variant, color, size) {
    if (!variant || !variant.options) return false;
    var hasColor = !color || variant.options.indexOf(color) !== -1;
    var hasSize = !size || variant.options.indexOf(size) !== -1;
    return hasColor && hasSize;
  }
  function findVaso(color, size) {
    return (
      VASO_VARIANTS.find(function (variant) {
        return variant.available !== false && variantMatches(variant, color, size);
      }) ||
      VASO_VARIANTS.find(function (variant) {
        return variantMatches(variant, color, size);
      }) ||
      null
    );
  }
  function optionAvailable(value, color, size, kind) {
    return VASO_VARIANTS.some(function (variant) {
      if (variant.available === false) return false;
      if (kind === 'color') return variantMatches(variant, value, size);
      return variantMatches(variant, color, value);
    });
  }
  function syncChoices(prefix) {
    if (!VASO_VARIANTS.length) return;
    var isSecond = prefix === 'b';
    var colorSel = isSecond ? '[data-hm-color-b]' : '[data-hm-color]';
    var sizeSel = isSecond ? '[data-hm-size-b]' : '[data-hm-size]';
    var color = selectedValue(colorSel);
    var size = selectedValue(sizeSel);
    document.querySelectorAll(colorSel).forEach(function (btn) {
      var value = btn.getAttribute(isSecond ? 'data-hm-color-b' : 'data-hm-color');
      var ok = optionAvailable(value, color, '', 'color');
      btn.hidden = !ok;
      btn.disabled = !ok;
      if (!ok) btn.classList.remove('is-selected');
    });
    color = selectedValue(colorSel);
    document.querySelectorAll(sizeSel).forEach(function (btn) {
      var value = btn.getAttribute(isSecond ? 'data-hm-size-b' : 'data-hm-size');
      var ok = optionAvailable(value, color, size, 'size');
      btn.hidden = !ok;
      btn.disabled = !ok;
      if (!ok) btn.classList.remove('is-selected');
    });
    if (!document.querySelector(colorSel + '.is-selected')) {
      var firstColor = document.querySelector(colorSel + ':not([hidden])');
      if (firstColor) firstColor.classList.add('is-selected');
    }
    if (!document.querySelector(sizeSel + '.is-selected')) {
      var firstSize = document.querySelector(sizeSel + ':not([hidden])');
      if (firstSize) firstSize.classList.add('is-selected');
    }
  }
  function selectedVaso(prefix) {
    var color = selectedValue(prefix === 'b' ? '[data-hm-color-b]' : '[data-hm-color]');
    var size = selectedValue(prefix === 'b' ? '[data-hm-size-b]' : '[data-hm-size]');
    var vaso = findVaso(color, size);
    if (vaso) return vaso;
    var sku = '';
    if (size && color) {
      var sizeCode = /250/.test(size) ? '2' : '1';
      var colorCode = /rosa/i.test(color) ? 'R' : /violeta|lila|lavanda/i.test(color) ? 'V' : 'M';
      sku = 'V' + sizeCode + colorCode;
    }
    return vaso || (SKU_MAP[sku] ? { id: SKU_MAP[sku], sku: sku, available: true, title: sku } : null);
  }

  function setPreview(name, src) {
    src = src || '';
    document.querySelectorAll('[data-hm-preview="' + name + '"]').forEach(function (wrap) {
      var imgs = wrap.querySelectorAll('.hm-preview__img');
      if (!imgs.length) return;
      var on = wrap.querySelector('.hm-preview__img.is-on') || imgs[0];
      var off = imgs[0] === on ? imgs[1] : imgs[0];
      if (!off) off = on;
      var current = on.getAttribute('src') || '';
      if (current === src) return;
      if (!src) {
        on.classList.remove('is-on');
        return;
      }
      function reveal() {
        off.classList.add('is-on');
        if (on !== off) on.classList.remove('is-on');
      }
      if ((off.getAttribute('src') || '') === src && off.complete) {
        reveal();
        return;
      }
      off.onload = function () {
        off.onload = null;
        reveal();
      };
      off.setAttribute('src', src);
      if (off.complete) {
        off.onload = null;
        reveal();
      }
    });
  }

  /** Packs de la app: el nombre del color elegido bajo sus muestras. */
  function paintSwatchNames() {
    if (!config.appPacks) return;
    document.querySelectorAll('#happymami-bundle .hm-swatches').forEach(function (row) {
      var on = row.querySelector('.hm-swatch.is-selected');
      var name = row.nextElementSibling && row.nextElementSibling.classList.contains('hm-swatch-name')
        ? row.nextElementSibling
        : null;
      if (!name) {
        name = document.createElement('p');
        name.className = 'hm-swatch-name';
        row.parentNode.insertBefore(name, row.nextSibling);
      }
      name.textContent = on ? on.getAttribute('title') || on.getAttribute('aria-label') || '' : '';
    });
  }

  /**
   * Fotos por color (app → Bundles): la galería de la ficha salta a la foto del pack en el color elegido.
   * Se busca por id de media y, si la galería no lo tiene, por el nombre del archivo.
   */
  var lastPackMedia = '';
  function showPackMedia() {
    var pack = PACKS[state.pack] || {};
    var map = pack.colorMedia;
    if (!map) return;
    var color = String(selectedValue('[data-hm-color]') || '').toLowerCase();
    var media = map[color] || map['*'];
    if (!media) return;
    var gallery = document.querySelector('media-gallery');
    if (!gallery || typeof gallery.setActiveMedia !== 'function') return;
    var target = (config.sectionId || '') + '-' + media.id;
    if (!gallery.querySelector('[data-media-id="' + target + '"]')) {
      var file = String(media.url || '').split('?')[0].split('/').pop();
      target = '';
      if (file) {
        gallery.querySelectorAll('[data-media-id]').forEach(function (item) {
          if (target) return;
          var img = item.querySelector('img');
          if (img && String(img.currentSrc || img.src || '').indexOf(file) >= 0) target = item.getAttribute('data-media-id');
        });
      }
    }
    if (!target || target === lastPackMedia) return;
    lastPackMedia = target;
    gallery.setActiveMedia(target, false, false);
  }

  function updatePreviews() {
    paintSwatchNames();
    showPackMedia();
    var vaso = selectedVaso();
    setPreview('vaso', vaso && vaso.image ? vaso.image : '');
    var vasoB = state.secondDifferent ? selectedVaso('b') : null;
    setPreview('vaso-b', vasoB && vasoB.image ? vasoB.image : '');
    Object.keys(EXTRA_PRODUCTS).forEach(function (key) {
      var extra = selectedExtra(key);
      var product = EXTRA_PRODUCTS[key] || {};
      var src = (extra && extra.image) || product.featuredImage || '';
      setPreview('extra-' + key, src);
    });
    updateCta();
  }

  function mountOptions() {
    var options = document.getElementById('hm-pack-options');
    var pack = document.querySelector('.hm-pack.is-selected');
    var slot = pack && pack.querySelector('[data-hm-slot]');
    if (options && slot) slot.appendChild(options);
    paintSwatches();
  }

  function paintSwatches() {
    var colors = Object.assign({}, config.colorHex || {}, config.vasoColors || {});
    document.querySelectorAll('.hm-swatch').forEach(function (btn) {
      var name =
        btn.getAttribute('data-hm-color') ||
        btn.getAttribute('data-hm-color-b') ||
        btn.getAttribute('data-value') ||
        '';
      var hex = btn.getAttribute('data-hm-hex') || colors[name];
      if (!hex && name) {
        var lower = name.toLowerCase();
        Object.keys(colors).some(function (key) {
          if (key.toLowerCase() === lower) {
            hex = colors[key];
            return true;
          }
          return false;
        });
      }
      if (!hex) return;
      btn.style.setProperty('--hm-swatch', hex);
      btn.style.backgroundColor = hex;
      btn.setAttribute('data-hm-hex', hex);
      btn.setAttribute('data-hm-swatch', hex);
    });
  }

  function setPanel(el, show) {
    if (!el) return;
    el.hidden = !show;
    el.classList.remove('is-showing');
    if (show) {
      requestAnimationFrame(function () {
        el.classList.add('is-showing');
      });
    }
  }

  function setSecondOpen(show) {
    var el = document.querySelector('[data-hm-second]');
    var btn = document.querySelector('[data-hm-toggle-second]');
    if (btn) btn.setAttribute('aria-expanded', show ? 'true' : 'false');
    if (!el) return;
    el.classList.toggle('is-open', !!show);
    el.setAttribute('aria-hidden', show ? 'false' : 'true');
  }

  function selectPack(packId) {
    state.pack = packId;
    var packCfg = PACKS[packId] || {};
    document.querySelectorAll('.hm-pack').forEach(function (pack) {
      pack.classList.toggle('is-selected', pack.getAttribute('data-pack') === packId);
    });
    var packEl = document.querySelector('.hm-pack.is-selected');
    var bottles = Number(packCfg.bottles || (packEl && packEl.getAttribute('data-bottles')) || 1);
    var extrasFromDom = (packEl && packEl.getAttribute('data-extras') || '')
      .split(',')
      .map(function (item) {
        return item.trim();
      })
      .filter(Boolean);
    var extrasList = packCfg.extras && packCfg.extras.length ? packCfg.extras : extrasFromDom;
    if (PACKS[packId] && extrasList.length) PACKS[packId].extras = extrasList;
    if (PACKS[packId] && bottles) PACKS[packId].bottles = bottles;
    var onePackColor = !!packCfg.packColor;
    var secondBtn = document.querySelector('[data-hm-toggle-second]');
    if (secondBtn) secondBtn.hidden = bottles <= 1 || onePackColor;
    var shownExtras = 0;
    document.querySelectorAll('[data-hm-pack-extra]').forEach(function (picker) {
      var mine = picker.getAttribute('data-hm-pack-extra') === packId;
      picker.hidden = !mine;
      if (mine) shownExtras += 1;
    });
    setPanel(
      document.querySelector('[data-hm-extras]'),
      config.appPacks ? shownExtras > 0 : extrasList.length > 0
    );
    var colorLabel = document.querySelector('[data-hm-color-label]');
    if (colorLabel && !config.singlePack) {
      if (!colorLabel.hasAttribute('data-hm-own-label')) colorLabel.setAttribute('data-hm-own-label', colorLabel.textContent);
      colorLabel.textContent = onePackColor
        ? colorLabel.getAttribute('data-hm-pack-label') || colorLabel.getAttribute('data-hm-own-label')
        : colorLabel.getAttribute('data-hm-own-label');
    }
    if (bottles <= 1 || onePackColor) {
      state.secondDifferent = false;
      setSecondOpen(false);
    }
    mountOptions();
    updateCta();
    updatePreviews();
  }

  // ¿Falta algo por elegir? Sin marcar nada en pantalla: solo para el texto del botón.
  function ctaReady() {
    var root = document.getElementById('happymami-bundle');
    if (!root) return true;
    if (!config.cupMode && !normalizeAnatomy(state.teatSku || storageGet(STORAGE_KEY))) return false;
    var groups = root.querySelectorAll('[data-hm-required]');
    for (var i = 0; i < groups.length; i += 1) {
      var group = groups[i];
      if (!sectionVisible(group) || group.querySelector('.hm-extra__missing')) continue;
      if (!group.querySelector('.is-selected')) return false;
    }
    return true;
  }

  function updateCta() {
    var button = document.getElementById('happymami-add-bundle');
    var label = button && button.querySelector('[data-hm-cta-label]');
    if (label && !button.classList.contains('loading')) {
      var ready = ctaReady();
      var pack = PACKS[state.pack] || {};
      var withPrice = config.appPacks && ready && pack.priceLabel && config.copy && config.copy.addWithPrice;
      label.textContent = withPrice
        ? String(config.copy.addWithPrice).replace(/\{\{\s*price\s*\}\}/, pack.priceLabel)
        : ready
          ? hmMsg('bundle.add_to_cart', 'Añadir al carrito')
          : hmMsg('bundle.choose_options', 'Elegir opciones');
    }
  }

  function setCtaLoading(on) {
    var button = document.getElementById('happymami-add-bundle');
    if (!button) return;
    button.disabled = on;
    button.classList.toggle('loading', on);
    var spinner = button.querySelector('.loading__spinner');
    if (spinner) spinner.classList.toggle('hidden', !on);
    var label = button.querySelector('[data-hm-cta-label]');
    if (!label) return;
    if (on) {
      button.setAttribute('data-idle-label', label.textContent);
      label.textContent = hmMsg('bundle.adding', 'Añadiendo al carrito');
    } else {
      label.textContent = button.getAttribute('data-idle-label') || label.textContent;
      updateCta();
    }
  }

  function designChoices(choices) {
    if (Array.isArray(choices) && choices.length) return choices;
    try {
      var parsed = JSON.parse(storageGet(CHOICES_KEY) || '[]');
      if (Array.isArray(parsed) && parsed.length) return parsed;
    } catch (e) {}
    return [];
  }

  function openDesignPanel(box) {
    if (!box) return;
    box.hidden = false;
  }

  function renderDesign(choices, teatSku) {
    var root = document.getElementById('happymami-bundle');
    var box = root ? root.querySelector('[data-hm-design]') : null;
    var list = root ? root.querySelector('[data-hm-design-list]') : null;
    if (!box || !list) return;
    box.hidden = false;
    var rows = designChoices(choices).filter(function (row) {
      return row && (row.titulo || row.opcion) && row.step !== 'M5';
    });
    if (typeof window.happymamiLocalizeChoices === 'function') rows = window.happymamiLocalizeChoices(rows);
    if (!rows.length && teatSku) rows = [{ titulo: 'Tetina', opcion: teatSku }];
    if (!rows.length) {
      list.innerHTML = '<div>' + hmMsg('bundle.custom_teats', 'Tu tetina a medida') + '</div>';
      return;
    }
    list.innerHTML = rows
      .map(function (row, index) {
        var title = String(row.titulo || '').replace(/</g, '');
        var option = String(row.opcion || '')
          .replace(/</g, '')
          .replace(/\n/g, ' ');
        var step = String(row.step || ['M1', 'M2', 'M3', 'M4'][index] || '').replace(/[^\w]/g, '');
        var inner = '<span class="hm-design__label">' + title + ': </span><span class="hm-design__value">' + option + '</span>';
        if (!step) return '<div>' + inner + '</div>';
        return '<button type="button" class="hm-design__row" data-hm-edit-step="' + step + '">' + inner + '</button>';
      })
      .join('');
    openDesignPanel(box);
  }

  function readCodes() {
    try {
      var parsed = JSON.parse(storageGet(CODES_KEY) || '[]');
      if (Array.isArray(parsed) && parsed.length) return parsed;
    } catch (e) {}
    try {
      var choices = JSON.parse(storageGet(CHOICES_KEY) || '[]');
      return (Array.isArray(choices) ? choices : [])
        .filter(function (row) {
          return row && row.step && row.code != null;
        })
        .map(function (row) {
          return { step: row.step, code: String(row.code) };
        });
    } catch (e) {}
    return [];
  }

  function showVasoSelector(teatSku, choices, animated, opts) {
    opts = opts || {};
    state.teatSku = normalizeAnatomy(teatSku);
    var wizard = document.getElementById('happymami-wizard-container');
    var selector = document.getElementById('happymami-vaso-selector');
    var status = document.querySelector('[data-hm-status-after]');
    var success = document.querySelector('#happymami-bundle [data-hm-success]');
    if (status) status.textContent = hmMsg('bundle.status_choose', 'Elige el flujo, el pack y las opciones del biberón.');
    var storedChoices = [];
    try {
      storedChoices = JSON.parse(storageGet(CHOICES_KEY) || '[]');
    } catch (e) {}
    renderDesign(choices && choices.length ? choices : storedChoices, teatSku);
    selectPack(state.pack || 'one');
    if (animated && window.happymamiFlow && window.happymamiFlow.celebrate) {
      window.happymamiFlow.celebrate(wizard, selector, opts.skipSuccess ? null : success, {
        successMs: 1600,
        scrollTo: document.getElementById('happymami-bundle'),
      });
      return;
    }
    if (wizard) wizard.hidden = true;
    if (selector) selector.hidden = false;
  }

  function showWizard(animated, edit) {
    var wizard = document.getElementById('happymami-wizard-container');
    var selector = document.getElementById('happymami-vaso-selector');
    function startEdit() {
      document.dispatchEvent(
        new CustomEvent('happymami:edit', {
          bubbles: true,
          detail: {
            mode: (edit && edit.mode) || 'all',
            step: edit && edit.step,
            codes: readCodes(),
            choices: (function () {
              try {
                return JSON.parse(storageGet(CHOICES_KEY) || '[]');
              } catch (e) {
                return [];
              }
            })(),
          },
        })
      );
    }
    if (animated && window.happymamiFlow) {
      window.happymamiFlow.swap(selector, wizard, {
        scroll: true,
        scrollEl: document.getElementById('happymami-bundle') || wizard,
        prepare: startEdit,
      });
      return;
    }
    if (wizard) wizard.hidden = false;
    if (selector) selector.hidden = true;
    if (edit) startEdit();
  }

  function colorFamily(lower) {
    var found = '';
    Object.keys(COLOR_FAMILIES).some(function (family) {
      if (COLOR_FAMILIES[family].some(function (word) { return lower.indexOf(word) >= 0; })) found = family;
      return !!found;
    });
    return found;
  }

  /** Words to look for in an extra's colour: the name, its colour in every language, then the closest colours. */
  function colorWords(name) {
    var lower = String(name || '').toLowerCase();
    var words = [lower];
    var family = colorFamily(lower);
    if (!family) return words;
    words = words.concat(COLOR_FAMILIES[family]);
    (COLOR_ALIASES[family] || []).forEach(function (alias) {
      words = words.concat(COLOR_FAMILIES[alias] || [alias]);
    });
    return words;
  }

  /** The variant of an extra in the pack colour (exact name first, then the closest colour). */
  function extraInPackColor(product) {
    var color = selectedValue('[data-hm-color]');
    var index = -1;
    (product.options || []).some(function (option, i) {
      if (COLOR_RE.test(option.name)) index = i;
      return index >= 0;
    });
    var available = product.variants.filter(function (variant) {
      return variant.available !== false;
    });
    var pool = available.length ? available : product.variants;
    if (index < 0 || !color) return pool[0] || null;
    var exact = pool.filter(function (variant) {
      return String(variant.options[index] || '').toLowerCase() === String(color).toLowerCase();
    })[0];
    if (exact) return exact;
    var words = colorWords(color);
    for (var w = 0; w < words.length; w += 1) {
      var hit = pool.filter(function (variant) {
        return String(variant.options[index] || '').toLowerCase().indexOf(words[w]) >= 0;
      })[0];
      if (hit) return hit;
    }
    return pool[0] || null;
  }

  function selectedExtra(key) {
    var product = EXTRA_PRODUCTS[key];
    if (!product || !product.variants || !product.variants.length) return null;
    if (product.variants.length === 1) return product.variants[0];
    var packCfg = PACKS[state.pack] || {};
    if (config.appPacks && packCfg.packColor) return extraInPackColor(product);
    var root = document.querySelector('[data-hm-extra="' + key + '"]');
    if (!root) return null;
    var values = [];
    root.querySelectorAll('.hm-extra-choice.is-selected').forEach(function (btn) {
      values[Number(btn.getAttribute('data-hm-extra-option'))] = btn.getAttribute('data-value');
    });
    return (
      product.variants.find(function (variant) {
        return (
          variant.options &&
          values.every(function (value, index) {
            return !value || variant.options[index] === value;
          })
        );
      }) || null
    );
  }

  function sanitizePropKey(name) {
    var key = String(name || '')
      .replace(/[\[\]]/g, '')
      .replace(/:/g, '')
      .trim();
    if (!key || key.charAt(0) === '_') return '';
    return key.length > 40 ? key.slice(0, 40) : key;
  }

  function choiceProperties() {
    var choices = [];
    try {
      var parsed = JSON.parse(storageGet(CHOICES_KEY) || '[]');
      choices = Array.isArray(parsed) ? parsed : [];
    } catch (e) {}
    var props = {};
    choices.forEach(function (row) {
      if (!row || !row.titulo) return;
      var key = sanitizePropKey(row.titulo);
      if (!key || key === 'Tetina' || key === 'Pack' || key === 'Vaso' || key === 'Producto') return;
      var val = String(row.opcion || '').trim();
      if (val) props[key] = val;
    });
    return props;
  }

  // Código de las cuatro respuestas (P1-P2-P3-P4 = M1-M4), solo cifras y en ese orden, igual en todos los idiomas.
  // Si falta alguna respuesta no se escribe nada: un código a medias no sirve.
  function choiceCode() {
    var order = ['M1', 'M2', 'M3', 'M4'];
    var byStep = {};
    readCodes().forEach(function (row) {
      if (row && row.step) byStep[row.step] = String(row.code);
    });
    var out = '';
    for (var i = 0; i < order.length; i += 1) {
      if (!/^[1-3]$/.test(byStep[order[i]] || '')) return '';
      out += byStep[order[i]];
    }
    return out;
  }

  function checkoutKeys() {
    var code = String((config && config.locale) || 'es').toLowerCase();
    if (code.indexOf('en') === 0) return { cup: 'Cup', color: 'Colour', size: 'Size', teat: 'Teat', product: 'Product' };
    if (code.indexOf('it') === 0) return { cup: 'Bicchiere', color: 'Colore', size: 'Misura', teat: 'Tettarella', product: 'Prodotto' };
    if (code.indexOf('pt') === 0) return { cup: 'Copo', color: 'Cor', size: 'Tamanho', teat: 'Tetina', product: 'Produto' };
    return { cup: 'Vaso', color: 'Color', size: 'Tamaño', teat: 'Tetina', product: 'Producto' };
  }

  function optionLabel(selector) {
    var el = document.querySelector(selector);
    if (!el) return '';
    var block = el.closest('.hm-option');
    var label = block && block.querySelector('.hm-option__label');
    return sanitizePropKey(label ? label.textContent : '');
  }

  function vasoChoiceProps(vaso, prefix) {
    var colorSel = prefix === 'b' ? '[data-hm-color-b]' : '[data-hm-color]';
    var sizeSel = prefix === 'b' ? '[data-hm-size-b]' : '[data-hm-size]';
    var color = selectedValue(colorSel);
    var size = selectedValue(sizeSel);
    if (vaso && vaso.options && vaso.options.length) {
      color = color || vaso.options[0];
      size = size || vaso.options[1];
    }
    var keys = checkoutKeys();
    var sku = (vaso && (vaso.sku || vaso.title)) || '';
    var props = { _tipo: 'vaso', _hm_vaso: sku };
    if (sku) props[keys.cup] = sku;
    if (color) {
      props._hm_color = String(color).trim();
      props[optionLabel(colorSel) || keys.color] = props._hm_color;
    }
    if (size) {
      props._hm_size = String(size).trim();
      props[optionLabel(sizeSel) || keys.size] = props._hm_size;
    }
    return props;
  }

  function teatLineProps(shared, choices, sku) {
    var keys = checkoutKeys();
    var props = Object.assign({}, shared, choices, { _tipo: 'tetina', _hm_tetina: sku });
    if (sku) props[keys.teat] = sku;
    return props;
  }

  function bottleLineProps(vaso, prefix) {
    var props = Object.assign({}, vasoChoiceProps(vaso, prefix || ''));
    if (config.cupMode) props._tipo = 'biberon';
    return props;
  }

  function cupLineProps(key, extra) {
    var props = extraChoiceProps(key, extra);
    props._tipo = 'taza';
    delete props.Producto;
    delete props.Product;
    delete props.Prodotto;
    delete props.Produto;
    delete props._hm_product;
    return props;
  }

  function extraChoiceProps(key, extra) {
    var product = EXTRA_PRODUCTS[key] || {};
    var sku = extra.sku || extra.title || '';
    var props = { _tipo: product.role || key, _hm_product: sku };
    if (sku) props[checkoutKeys().product] = sku;
    var names = product.options || [];
    (extra.options || []).forEach(function (val, i) {
      if (!val || val === 'Default Title') return;
      var nameObj = names[i];
      var name = (nameObj && nameObj.name) || 'Opción ' + (i + 1);
      var propKey = sanitizePropKey(name);
      if (propKey) props[propKey] = String(val);
    });
    return props;
  }

  function line(id, qty, props) {
    return { id: id, quantity: qty, properties: props };
  }

  // Klaviyo saca un «Added to Cart» por cada línea del alta (biberón, tetina, regalo…), cada uno con sus datos y sin
  // las propiedades de línea. Este evento propio lleva el pack entero en una sola vez: biberón, tetina(s), elecciones
  // de la tetina y todas las líneas, para poder montar un flujo y reconstruir el carrito con las dos piezas.
  function klaviyoLine(item) {
    var props = item.properties || {};
    var url = item.url || '';
    return {
      ProductName: item.product_title || item.title || '',
      VariantName: item.variant_title || '',
      SKU: item.sku || '',
      ProductID: item.product_id || '',
      VariantID: item.variant_id || item.id || '',
      Quantity: item.quantity || 1,
      Price: (item.final_price != null ? item.final_price : item.price || 0) / 100,
      ImageURL: item.image || (item.featured_image && item.featured_image.url) || '',
      URL: url ? (/^https?:/.test(url) ? url : window.location.origin + url) : '',
      Type: props._tipo || (props._hm_incluido ? 'incluido' : ''),
    };
  }

  function trackKlaviyoPack(response, items, packId, packLabel, bundleId, packPriceCents, choices) {
    try {
      var respLines = (response && response.items) || (response && response.id ? [response] : []);
      // Shopify fusiona la tetina y el vaso en una sola línea del carrito al añadir (función de bundles), así que la
      // tetina solo se ve en lo que enviamos: ahí están su variante, su SKU y su cantidad.
      var sent = function (tipo) {
        return (items || []).filter(function (it) {
          return it && it.properties && it.properties._tipo === tipo;
        });
      };
      var teatsSent = sent('tetina');
      var vasosSent = sent('vaso').concat(sent('biberon'));
      var all = respLines.map(klaviyoLine);
      var merged = respLines.filter(function (item) {
        var pr = item.properties || {};
        return pr._bundle_id === bundleId && !pr._hm_incluido;
      })[0];
      var data = {
        $event_id: 'pack-' + bundleId,
        $value: (packPriceCents || 0) / 100,
        BundleID: bundleId,
        PackID: String(packId || ''),
        PackTitle: packLabel,
        Currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR',
        ItemCount: all.length,
        ItemNames: all.map(function (line) { return line.ProductName; }),
        Items: all,
      };
      if (merged) {
        var bottle = klaviyoLine(merged);
        data['Bottle Product Name'] = bottle.ProductName;
        data['Bottle Variant Name'] = bottle.VariantName;
        data['Bottle SKU'] = bottle.SKU;
        data['Bottle Variant ID'] = bottle.VariantID;
        data['Bottle Quantity'] = bottle.Quantity;
        data['Bottle Image URL'] = bottle.ImageURL;
        data['Bottle URL'] = bottle.URL;
        var visible = {};
        Object.keys(merged.properties || {}).forEach(function (key) {
          if (key.charAt(0) !== '_') visible[key] = merged.properties[key];
        });
        data['Cart Line Properties'] = visible;
      }
      var teat = teatsSent[0];
      if (teat) {
        data['Teat SKU'] = (teat.properties && teat.properties._hm_tetina) || '';
        data['Teat Variant ID'] = teat.id;
        data['Teat Quantity'] = teat.quantity;
        // Código de las cuatro respuestas (P1-P4), solo cifras: igual en todos los idiomas, para segmentar sin textos.
        if (teat.properties && teat.properties._hm_choice) data['Teat Choice Code'] = String(teat.properties._hm_choice);
      }
      if (teatsSent[1]) {
        data['Teat 2 SKU'] = (teatsSent[1].properties && teatsSent[1].properties._hm_tetina) || '';
        data['Teat 2 Variant ID'] = teatsSent[1].id;
        data['Teat 2 Quantity'] = teatsSent[1].quantity;
      }
      data.Teats = teatsSent.map(function (it) {
        return { SKU: (it.properties && it.properties._hm_tetina) || '', VariantID: it.id, Quantity: it.quantity };
      });
      data.Bottles = vasosSent.map(function (it) {
        return { SKU: (it.properties && (it.properties._hm_vaso || it.properties._hm_product)) || '', VariantID: it.id, Quantity: it.quantity };
      });
      Object.keys(choices || {}).forEach(function (key) {
        data['Teat choice: ' + key] = choices[key];
      });
      // Enlace que vuelve a montar el carrito con biberón + tetina (+ extras) sin las propiedades de línea.
      var permalink = (items || [])
        .filter(function (it) { return it && it.id; })
        .map(function (it) { return it.id + ':' + (it.quantity || 1); })
        .join(',');
      if (permalink) data['Rebuild Cart URL'] = window.location.origin + '/cart/' + permalink;
      window.__hmKlaviyoPack = window.__hmKlaviyoPack || {};
      window.__hmKlaviyoPack[bundleId] = true;
      window._learnq = window._learnq || [];
      window._learnq.push(['track', 'Added Pack to Cart', data]);
    } catch (e) {}
  }

  function cartUi() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }
  function applyPackDiscount(code, sectionsPayload) {
    if (!code) return Promise.resolve(null);
    var body = { discount: String(code).trim() };
    if (sectionsPayload && sectionsPayload.sections) {
      body.sections = sectionsPayload.sections;
      body.sections_url = sectionsPayload.sections_url;
    }
    return fetch(CART_UPDATE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body),
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) return null;
        return data;
      });
    }).catch(function () {
      return null;
    });
  }

  function sectionVisible(el) {
    if (!el) return false;
    if (el.hidden) return false;
    if (el.closest('[hidden]')) return false;
    var second = el.closest('.hm-second');
    if (second && !second.classList.contains('is-open')) return false;
    return true;
  }

  function clearInvalid() {
    document.querySelectorAll('#happymami-bundle .is-invalid').forEach(function (el) {
      el.classList.remove('is-invalid');
    });
  }

  function markInvalid(el, missing) {
    if (!el) return;
    el.classList.add('is-invalid');
    missing.push(el);
  }

  function requireExtra(key, missing) {
    var extraRoot = document.querySelector('[data-hm-extra="' + key + '"]');
    if (!sectionVisible(extraRoot)) return;
    extraRoot.querySelectorAll('[data-hm-required]').forEach(function (group) {
      if (!sectionVisible(group)) return;
      if (!group.querySelector('.is-selected')) markInvalid(group, missing);
    });
  }

  function requireSelected(selector, requiredKey, missing) {
    var section = document.querySelector('[data-hm-required="' + requiredKey + '"]');
    if (!sectionVisible(section)) return true;
    if (document.querySelector(selector + '.is-selected')) {
      section.classList.remove('is-invalid');
      return true;
    }
    markInvalid(section, missing);
    return false;
  }

  function scrollToFirstInvalid(missing) {
    if (!missing.length) return;
    missing.sort(function (a, b) {
      return a.getBoundingClientRect().top - b.getBoundingClientRect().top;
    });
    if (window.happymamiFlow) window.happymamiFlow.scrollTo(missing[0]);
  }

  function validateBundle(pack) {
    clearInvalid();
    var missing = [];
    if (!config.cupMode) requireSelected('[data-hm-flow]', 'flow', missing);
    else requireExtra('taza', missing);
    requireSelected('[data-hm-color]', 'color', missing);
    requireSelected('[data-hm-size]', 'size', missing);
    if (state.secondDifferent && pack && pack.bottles > 1) {
      if (!config.cupMode) requireSelected('[data-hm-flow-b]', 'flow-b', missing);
      else requireExtra('taza-b', missing);
      requireSelected('[data-hm-color-b]', 'color-b', missing);
      requireSelected('[data-hm-size-b]', 'size-b', missing);
    }
    var extrasWrap = document.querySelector('[data-hm-extras]');
    if (extrasWrap && !extrasWrap.hidden && pack && pack.extras) {
      pack.extras.forEach(function (key) {
        var extraRoot = document.querySelector('[data-hm-extra="' + key + '"]');
        if (!sectionVisible(extraRoot)) return;
        var groups = extraRoot.querySelectorAll('[data-hm-required]');
        if (groups.length) {
          groups.forEach(function (group) {
            if (!group.querySelector('.is-selected')) markInvalid(group, missing);
          });
          return;
        }
        if (extraRoot.getAttribute('data-hm-required') && extraRoot.querySelector('.hm-extra__missing')) {
          markInvalid(extraRoot, missing);
          return;
        }
        var extra = selectedExtra(key);
        if (!extra || !extra.id) markInvalid(extraRoot, missing);
      });
    }
    if (missing.length) {
      scrollToFirstInvalid(missing);
      return false;
    }
    return true;
  }

  function addBundle() {
    var anatomy = normalizeAnatomy(state.teatSku || storageGet(STORAGE_KEY));
    var pack = PACKS[state.pack] || {};
    if (!config.cupMode && !anatomy) {
      var wizard = document.getElementById('happymami-wizard-container');
      if (window.happymamiFlow) window.happymamiFlow.scrollTo(wizard || document.getElementById('happymami-bundle'));
      return;
    }
    if (!validateBundle(pack)) return;

    var flowA = selectedAttr('[data-hm-flow]', 'data-hm-flow');
    var skuA = teatFromFlow(anatomy, flowA);
    var teatId = resolveTeatId(skuA);
    var vaso = selectedVaso();
    var cup = config.cupMode ? selectedExtra('taza') : null;

    if (config.cupMode && (!cup || !cup.id)) {
      validateBundle(pack);
      return;
    }
    if (!config.cupMode && (!skuA || !teatId)) {
      alert(
        hmMsg('bundle.teat_sku_alert', 'Tetina {{ sku }} calculada, pero no hay una variante de Shopify con ese SKU. En Personalizar → Happymami elige el producto tetina, o pon SKU T1L–T4C (o N10, N27…) en sus variantes.', {
          sku: skuA || anatomy,
        })
      );
      return;
    }
    if (!vaso || !vaso.id) {
      requireSelected('[data-hm-color]', 'color', []);
      requireSelected('[data-hm-size]', 'size', []);
      return;
    }

    var bundleId = uuid();
    var items = [];
    var packLabel =
      (document.querySelector('.hm-pack.is-selected .hm-pack__name') || {}).textContent || hmMsg('bundle.bottle_default', 'Biberón completo');
    packLabel = String(packLabel).trim();
    var packPrice = pack.priceCents || parseMoneyCents(pack.priceLabel);
    var discountCode = packDiscountCode(pack, state.pack);
    var shared = {
      _bundle_id: bundleId,
      _bundle_title: packLabel,
      _hm_pack: String(state.pack || ''),
      _bundle_price: packPrice ? String(packPrice) : '',
      _hm_locale: String((config && config.locale) || 'es').toLowerCase(),
      // Para Klaviyo y los píxeles: cada línea del alta lleva la tetina (SKU y variante) y el regalo del pack,
      // así el evento de «añadir al carrito» permite reconstruir el biberón y la tetina aunque solo recoja una línea.
      _hm_tetina_sku: String(skuA || ''),
      _hm_tetina_variant: String(teatId || ''),
      _hm_choice: choiceCode(),
      _hm_incluido_variant: String((window.happymamiIncluido && window.happymamiIncluido.variantId) || ''),
    };

    var teatPropsA = teatLineProps(shared, choiceProperties(), skuA);

    if (state.secondDifferent && pack.bottles > 1) {
      var vasoB = selectedVaso('b');
      if (!vasoB || !vasoB.id) {
        validateBundle(pack);
        return;
      }
      if (config.cupMode) {
        var cupB = selectedExtra('taza-b');
        if (!cupB || !cupB.id) {
          validateBundle(pack);
          return;
        }
        items.push(line(cup.id, 1, Object.assign({}, shared, cupLineProps('taza', cup))));
        items.push(line(cupB.id, 1, Object.assign({}, shared, cupLineProps('taza-b', cupB))));
      } else {
        var flowB = selectedAttr('[data-hm-flow-b]', 'data-hm-flow-b');
        var skuB = teatFromFlow(anatomy, flowB);
        var teatIdB = resolveTeatId(skuB);
        if (!skuB || !teatIdB) {
          alert(
            hmMsg('bundle.teat_sku_alert', 'Tetina {{ sku }} calculada, pero no hay una variante de Shopify con ese SKU. En Personalizar → Happymami elige el producto tetina, o pon SKU T1L–T4C (o N10, N27…) en sus variantes.', {
              sku: skuB || anatomy,
            })
          );
          return;
        }
        if (skuA === skuB) {
          items.push(line(teatId, 2, teatPropsA));
        } else {
          items.push(line(teatId, 1, teatPropsA));
          items.push(line(teatIdB, 1, teatLineProps(shared, choiceProperties(), skuB)));
        }
      }
      items.push(line(vaso.id, 1, Object.assign({}, shared, bottleLineProps(vaso))));
      items.push(line(vasoB.id, 1, Object.assign({}, shared, bottleLineProps(vasoB, 'b'))));
    } else if (config.cupMode) {
      items.push(line(cup.id, pack.bottles, Object.assign({}, shared, cupLineProps('taza', cup))));
      items.push(line(vaso.id, pack.bottles, Object.assign({}, shared, bottleLineProps(vaso))));
    } else {
      items.push(line(teatId, pack.bottles, teatPropsA));
      items.push(line(vaso.id, pack.bottles, Object.assign({}, shared, bottleLineProps(vaso))));
    }

    var missingExtra = '';
    pack.extras.forEach(function (key) {
      var extra = selectedExtra(key);
      if (!extra || !extra.id) {
        missingExtra = EXTRA_PRODUCTS[key] && EXTRA_PRODUCTS[key].title ? EXTRA_PRODUCTS[key].title : key;
        return;
      }
      var extraQty = (EXTRA_PRODUCTS[key] && EXTRA_PRODUCTS[key].qty) || 1;
      items.push(line(extra.id, extraQty, Object.assign({}, shared, extraChoiceProps(key, extra))));
    });
    if (missingExtra) {
      validateBundle(pack);
      return;
    }

    var cart = cartUi();
    var payload = { items: items };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      payload.sections = cart.getSectionsToRender().map(function (section) {
        return section.id;
      });
      payload.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }

    setCtaLoading(true);
    jsonFetch(CART_ADD_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload),
    })
      .then(function (response) {
        trackKlaviyoPack(response, items, state.pack, packLabel, bundleId, packPrice, choiceProperties());
        if (!discountCode) return response;
        return applyPackDiscount(discountCode, payload).then(function (discounted) {
          return discounted || response;
        });
      })
      .then(function (response) {
        setCtaLoading(false);
        if (window.publish && window.PUB_SUB_EVENTS) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'happymami-bundle', cartData: response });
        }
        if (!cart) {
          window.location.href = CART_PAGE_URL;
          return;
        }
        if (!response.key && response.items && response.items[0]) response.key = response.items[0].key;
        try {
          if (typeof cart.renderContents === 'function' && response.sections) {
            cart.renderContents(response);
            return;
          }
        } catch (e) {}
        window.location.href = CART_PAGE_URL;
      })
      .catch(function (error) {
        setCtaLoading(false);
        alert(error.message || hmMsg('bundle.add_error', 'No se pudo añadir el pack al carrito.'));
      });
  }

  function bindChoice(selector, groupSelector, shouldSync) {
    document.querySelectorAll(selector).forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.querySelectorAll(groupSelector).forEach(function (el) {
          el.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');
        var section = btn.closest('[data-hm-required]');
        if (section) section.classList.remove('is-invalid');
        if (shouldSync !== false) {
          syncChoices(groupSelector.indexOf('-b]') !== -1 ? 'b' : '');
          updatePreviews();
        } else {
          updatePreviews();
        }
      });
    });
  }

  function bindExtraChoices() {
    var root = document.getElementById('happymami-bundle');
    if (!root) return;
    root.querySelectorAll('.hm-extra-choice').forEach(function (btn) {
        if (btn.hasAttribute('data-hm-bound')) return;
        btn.setAttribute('data-hm-bound', '');
        btn.addEventListener('click', function () {
          var key = btn.getAttribute('data-hm-extra-key');
          var option = btn.getAttribute('data-hm-extra-option');
          root
            .querySelectorAll('.hm-extra-choice[data-hm-extra-key="' + key + '"][data-hm-extra-option="' + option + '"]')
            .forEach(function (el) {
              el.classList.remove('is-selected');
            });
          btn.classList.add('is-selected');
          var section = btn.closest('[data-hm-required]');
          if (section) section.classList.remove('is-invalid');
          updatePreviews();
        });
      });
  }

  function init() {
    if (!document.getElementById('happymami-bundle')) return;

    bindChoice('[data-hm-color]', '[data-hm-color]');
    bindChoice('[data-hm-size]', '[data-hm-size]');
    bindChoice('[data-hm-color-b]', '[data-hm-color-b]');
    bindChoice('[data-hm-size-b]', '[data-hm-size-b]');
    bindChoice('[data-hm-flow]', '[data-hm-flow]', false);
    bindChoice('[data-hm-flow-b]', '[data-hm-flow-b]', false);
    bindExtraChoices();
    if (!document.querySelector('[data-hm-color].is-selected')) {
      var firstColor = document.querySelector('[data-hm-color]');
      if (firstColor) firstColor.classList.add('is-selected');
    }
    if (!document.querySelector('[data-hm-size].is-selected')) {
      var firstSize = document.querySelector('[data-hm-size]');
      if (firstSize) firstSize.classList.add('is-selected');
    }
    syncChoices();
    updatePreviews();

    document.querySelectorAll('[data-hm-select-pack]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectPack(btn.getAttribute('data-hm-select-pack'));
      });
    });

    var secondBtn = document.querySelector('[data-hm-toggle-second]');
    if (secondBtn) {
      secondBtn.addEventListener('click', function () {
        state.secondDifferent = !state.secondDifferent;
        setSecondOpen(state.secondDifferent);
        if (state.secondDifferent) {
          var c = document.querySelector('[data-hm-color-b]');
          var s = document.querySelector('[data-hm-size-b]');
          if (c && !document.querySelector('[data-hm-color-b].is-selected')) c.classList.add('is-selected');
          if (s && !document.querySelector('[data-hm-size-b].is-selected')) s.classList.add('is-selected');
          syncChoices('b');
        }
        updatePreviews();
      });
    }

    var designToggle = document.querySelector('[data-hm-design-toggle]');
    if (designToggle) {
      designToggle.addEventListener('click', function () {
        var box = document.querySelector('[data-hm-design]');
        if (!box) return;
        var closed = box.classList.toggle('is-closed');
        designToggle.setAttribute('aria-expanded', closed ? 'false' : 'true');
      });
    }

    var designList = document.querySelector('#happymami-bundle [data-hm-design-list]');
    if (designList) {
      designList.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-hm-edit-step]');
        if (!btn) return;
        if (window.happymamiFlow && window.happymamiFlow.busy) return;
        showWizard(true, { mode: 'one', step: btn.getAttribute('data-hm-edit-step') });
      });
    }

    var addBtn = document.getElementById('happymami-add-bundle');
    if (addBtn) addBtn.addEventListener('click', addBundle);

    var resetBtn = document.querySelector('#happymami-bundle [data-hm-reset]');
    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        if (window.happymamiFlow && window.happymamiFlow.busy) return;
        showWizard(true, { mode: 'all' });
      });
    }

    document.addEventListener('happymami:cancel-edit', function () {
      var sku = state.teatSku || normalizeAnatomy(storageGet(STORAGE_KEY));
      if (!sku) return;
      showVasoSelector(sku, null, true, { skipSuccess: true });
    });

    if (config.cupMode) {
      var wizard = document.getElementById('happymami-wizard-container');
      var selector = document.getElementById('happymami-vaso-selector');
      if (wizard) wizard.hidden = true;
      if (selector) selector.hidden = false;
      selectPack(state.pack || firstPackId);
    } else {
      var savedTeat = normalizeAnatomy(storageGet(STORAGE_KEY));
      if (savedTeat) showVasoSelector(savedTeat);
      else showWizard();
    }
  }

  document.addEventListener('happymami:pharma-ready', function () {
    if (!document.getElementById('happymami-bundle')) return;
    var sku = state.teatSku || normalizeAnatomy(storageGet(STORAGE_KEY));
    if (!sku) return;
    renderDesign(null, sku);
  });

  document.addEventListener('happymami:complete', function (event) {
    if (!document.getElementById('happymami-bundle')) return;
    var data = event.detail || {};
    var teatSku = normalizeAnatomy(data.teat || data.ref);
    if (!teatSku) return;
    storageSet(STORAGE_KEY, teatSku);
    var incomingChoices = data.choices || data.elecciones;
    if (incomingChoices && incomingChoices.length) {
      storageSet(CHOICES_KEY, JSON.stringify(incomingChoices));
    }
    if (data.codes && data.codes.length) storageSet(CODES_KEY, JSON.stringify(data.codes));
    showVasoSelector(teatSku, incomingChoices, true, { skipSuccess: !!data.fromEdit });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
